import { Helmet } from "react-helmet"
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useModuleSettings } from "../../components/moduleSettingsContext/ModuleSettingsContext";
import { notifications,showNotification} from "../../slices/notificationSlice";
import { useEffect, useState } from "react";
import moment from "moment";
import { getUserPermissions, isAdmin } from "../../common/LocalStorageService";
import Spinner from "../../components/spinner";
import DataTable from "react-data-table-component";
import { language } from "../../slices/languageSlice";
import ViewModal from "./modal";
import NotificationModel from "./notification_model"; // FIXED

export const Notification = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { notificationList, addNotificationData,showNotificationData,loading } = useSelector((state) => state.notification);
    const { filter, setFilter, search, setSearch, page, setPage, limit, setLimit, resetSettings } = useModuleSettings();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [data, setData] = useState({});
    const [field, setField] = useState({});

    // ADD NOTIFICATION MODAL STATE
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [update, setUpdate] = useState({ status: false, data: {} }    );

    useEffect(() => {
        if (filter === 'all') {
            return setFilter('');
        }
        dispatch(notifications({ filter, search, page, per_page: limit}));
    }, [dispatch, filter, search, page, limit,addNotificationData]);

  

    const handleView = (row) => {
        setField({
            title: "Notification Details",
            _title: "Title",
            message: "Message",
            language: "Notification type",
            date: "Date",   
            senderData:"sender user/member List"
        });
        dispatch(showNotification({ notifications_id: row.id }));
        // setData(row);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setField({});
        setData({});
        setIsModalOpen(false);
    };

    // FIXED ADD BUTTON LOGIC
    const handleAdd = () => {
        setUpdate({ status: false, data: {} });
        setIsAddModalOpen(true);
    };

    const handleCloseAddModal = () => {
        setUpdate({ status: false, data: {} });
        setIsAddModalOpen(false);
    };
    const getReadableType = (type) => {
  switch (type) {
    case "notify_all":
      return "Notify All";
    case "notify_all_users":
      return "Notify All Users";
    case "notify_all_members":
      return "Notify All Members";
    case "selected_users":
      return "Selected Users";
    case "selected_members":
      return "Selected Members";
    default:
      return type || "-";
  }
};
    const columns = [
        {
            name: "Sr No",
            selector: (row, index) => (page - 1) * limit + index + 1,
            sortable: false,
            maxWidth: "150px",
        },
        {
            name: "Title",
            selector: (row) => row?.title,
            minWidth: "250px",
        },
        {
            name: "Message Body",
            selector: (row) => row?.body,
            minWidth: "300px",
            maxWidth: "500px",
        },
         {
            name: "Notify for",
            selector: (row) => getReadableType(row?.for_user_type),
            minWidth: "150px",
            maxWidth: "200px",
        },
        {
            name: "Created Date",
            selector: (row) => moment(row.createdAt).format("DD-MMM-YYYY hh:mm:a"),
            minWidth: "300px",
            maxWidth: "300px",
            sortable: true,
        },
        {
            name: "Action",
            selector: (row) => (
                <button className="btn" onClick={() => handleView(row)}>
                    <i className="fe-eye font-22 avatar-title text-primary" />
                </button>
            ),
        },
    ];

    if (loading) return <Spinner />;

    return (
        <>
            <Helmet>
                <title>Tandemly | Notifications</title>
            </Helmet>

            <div className="content-page">
                <div className="col-md-12 col-xl-12 mt-1">
                    <div className="widget-rounded-circle card">
                        <div className="card-body">

                            <div className="row">
                                <DataTable
                                    columns={columns}
                                    data={notificationList.data}
                                    pagination
                                    paginationServer
                                    paginationTotalRows={notificationList?.paging?.total}
                                    paginationDefaultPage={page}
                                    paginationPerPage={limit}
                                    onChangePage={setPage}
                                    onChangeRowsPerPage={setLimit}
                                    subHeader
                                    subHeaderComponent={
                                        <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                            <div>
                                                {(isAdmin() || getUserPermissions("course").is_add) &&
                                                    <button className="btn btn-primary" onClick={handleAdd}>
                                                        Add
                                                    </button>
                                                }
                                            </div>
                                        </div>
                                    }
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            {/* VIEW MODAL */}
            <ViewModal
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                data={showNotificationData}
                field={field}
            />

            {/* ADD / EDIT NOTIFICATION MODAL */}
            <NotificationModel
                update={update} 
                isOpen={isAddModalOpen}
                onClose={handleCloseAddModal}
            />

        </>
    );
};
